// extracted by mini-css-extract-plugin
export default {"root":"ItemId_root__4QFnN"};